import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Popup = ({ title, description, icon, onClick, unsecure }) => {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        setOpen(true);
    }, []);

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            onClick && onClick();
        }, 150);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">
                        {title}
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Box textAlign="center" mb={2}>
                    <i className={icon} style={{ fontSize: '3rem', lineHeight: '5rem' }} />
                    <Typography variant="h6">
                        {title}
                    </Typography>
                    {unsecure ? (
                        <Typography variant="body2" dangerouslySetInnerHTML={{ __html: description }} />
                    ) : (
                        <Typography variant="body2">{description}</Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Ok, got it
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Popup;
